<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 42V42C11.685 42 9 39.315 9 36V36C9 32.685 11.685 30 15 30V30C18.315 30 21 32.685 21 36V36C21 39.315 18.315 42 15 42Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 42V42C32.685 42 30 39.315 30 36V36C30 32.685 32.685 30 36 30V30C39.315 30 42 32.685 42 36V36C42 39.315 39.315 42 36 42Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57 42V42C53.685 42 51 39.315 51 36V36C51 32.685 53.685 30 57 30V30C60.315 30 63 32.685 63 36V36C63 39.315 60.315 42 57 42Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 63V63C11.685 63 9 60.315 9 57V57C9 53.685 11.685 51 15 51V51C18.315 51 21 53.685 21 57V57C21 60.315 18.315 63 15 63Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 63V63C32.685 63 30 60.315 30 57V57C30 53.685 32.685 51 36 51V51C39.315 51 42 53.685 42 57V57C42 60.315 39.315 63 36 63Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57 63V63C53.685 63 51 60.315 51 57V57C51 53.685 53.685 51 57 51V51C60.315 51 63 53.685 63 57V57C63 60.315 60.315 63 57 63Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 21V21C11.685 21 9 18.315 9 15V15C9 11.685 11.685 9 15 9V9C18.315 9 21 11.685 21 15V15C21 18.315 18.315 21 15 21Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 21V21C32.685 21 30 18.315 30 15V15C30 11.685 32.685 9 36 9V9C39.315 9 42 11.685 42 15V15C42 18.315 39.315 21 36 21Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57 21V21C53.685 21 51 18.315 51 15V15C51 11.685 53.685 9 57 9V9C60.315 9 63 11.685 63 15V15C63 18.315 60.315 21 57 21Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
